import React from 'react';
import { connect } from 'react-redux';
import {
  Divider,
  Table,
} from 'semantic-ui-react';

export default function SystemTable(props) {
  return (
    <div style={{ margin: '12px 0' }}>
      <Table size="small">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell content="System Description" />
          </Table.Row>
          {
            props.systems.map((sys, i) => (
              <Table.Row key={i}>
                <Table.Cell content={sys.name} />
              </Table.Row>
            ))
          }
          {
            !props.systems.length &&
              <Table.Row warning>
                <Table.Cell content="Systems Not Found" />
              </Table.Row>
          }
        </Table.Header>
      </Table>
    </div>
  );
}
